"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _modalstatus = require("../../../state/actions/modalstatus");

var _modal = _interopRequireDefault(require("./modal"));

var _modal_definition = _interopRequireDefault(require("./modal_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// actions
// component
// definition

/* ========== ~~~~~~~~~~ MODAL : CONTAINER ~~~~~~~~~~ ========== */
// map state


var mapStateToProps = function mapStateToProps(_ref) {
  var appStatus = _ref.appStatus,
      modalStatus = _ref.modalStatus;
  return {
    currentPage: appStatus.currentPage,
    visible: modalStatus.visible,
    content: modalStatus.content,
    showCloseButton: modalStatus.showCloseButton
  };
}; // map actions


var mapDispatchToProps = {
  displayModal: _modalstatus.displayModal
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var ConnectedModal = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_modal.default);
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(ConnectedModal, _modal_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = ConnectedModal;
exports.default = _default;